/**
 * LogRocket integration (session replay).
 *
 * SDK loading: NOT loaded by tazio-fe (no NPM dependency, no <script> tag).
 *              The LogRocket snippet is injected externally when in use.
 * Global:      window.LogRocket
 * Env vars:    none
 *
 * Status: ACTIVE / opportunistic — only fires when the host page has
 *         loaded the LogRocket snippet.
 *
 * Existing call sites (as of 2026-04-13):
 *   - src/config.js:126-137              identify(email, traits) + track('sso')
 *   - src/utilities/commons.js:448       custom_event() forwards `${action}_${label}`
 *
 * LogRocket API used:
 *   window.LogRocket.identify(uid, traits)
 *   window.LogRocket.track(event_name)
 *
 * Naming convention: every public function is prefixed with `logrocket_` so
 * the LogRocket origin is obvious at every call site, even when imported
 * alongside other integration modules.
 */

export function logrocket_is_available() {
  return Boolean(window.LogRocket)
}

/**
 * Identify the current user.
 *   window.LogRocket.identify(uid, traits)
 *
 * @param {string} user_id
 * @param {Object} [traits]  - Custom variables (name, email, customer, ...).
 */
export function logrocket_identify(user_id, traits) {
  if (!logrocket_is_available()) return
  window.LogRocket.identify(user_id, traits || {})
}

/**
 * Apply the canonical SSO identify call currently used in src/config.js.
 *
 * @param {Object} sso - { displayName, email, token, customer, company }
 */
export function logrocket_identify_sso(sso) {
  logrocket_identify(sso.email, {
    name: sso.displayName,
    email: sso.email,
    customer: sso.customer,
    company: sso.company,
    token: sso.token,
  })
}

/**
 * Track an event (LogRocket only accepts the event name string).
 */
export function logrocket_track(event_name) {
  if (!logrocket_is_available()) return
  if (!event_name || typeof event_name !== 'string') return
  window.LogRocket.track(event_name)
}
